<template>
	<div class="page"  v-show="show">
		<div class="pagelist">
			<a class="jump" :class="{disabled: pstart}" :href="routerTo + (Number(current_page) - 1)">{{ $t('pagination.pre') }}</a>
			<a v-show="current_page>5" class="jump" :href="routerTo+1">1</a>
			<span class="ellipsis"  v-show="efont">...</span>
			<a
        class="jump"
        v-for="(num, idx) in indexs"
        :key="idx"
        :class="{bgprimary:current_page==num}"
        :href="routerTo+num">{{num}}</a>
			<span class="ellipsis"  v-show="ebehind">...</span>
			<a :class="{disabled:pend}" class="jump" :href="routerTo + (Number(current_page)+1)">{{ $t('pagination.next') }}</a>
			<!--<a v-show="current_page<pages-4" class="jump":href="routerTo + pages">{{pages}}</a>
			<span class="jumppoint">跳转到：</span>
			<span class="jumpinp"><input type="text" v-model="changePage"></span>
			<span class="jump gobtn" @click="jumpPage(changePage)">GO</span>-->
		</div>
	</div>
</template>
<script>
	export default {
		props:['page','totalCount'],
		data() {
			return {
        current_page: 1, //当前页
        pages: 1, //总页数
        changePage:'',//跳转页
        nowIndex:0,
				routerTo:null,
			}
    },
		computed:{
			show(){
					return this.pages && this.pages !=1
			},
			pstart() {
				return this.current_page == 1;
			},
			pend() {
				return this.current_page == this.pages;
			},
			efont() {
				if (this.pages <= 7) return false;
				return this.current_page > 5
			},
			ebehind() {
				if (this.pages <= 7) return false;
				var nowAy = this.indexs;
				return nowAy[nowAy.length - 1] != this.pages;
			},
			indexs() {

				var left = 1,
					right = this.pages,
					ar = [];
				if (this.pages >= 7) {
					if (this.current_page > 5 && this.current_page < this.pages - 4) {
						left = Number(this.current_page) - 3;
						right = Number(this.current_page) + 3;
					} else {
						if (this.current_page <= 5) {
							left = 1;
							right = 7;
						} else {
							right = this.pages;

							left = this.pages - 6;
						}
					}
				}
				while (left <= right) {
					ar.push(left);
					left++;
				}
				return ar;
			},
		},
		methods: {
			pre(){
				this.$router.push(this.routerTo + this.current_page-- )
			},
			next(){
				this.$router.push(this.routerTo + this.current_page++ )
			},
			jumpPage(id) {
				this.current_page = id;
				this.$router.push(this.routerTo + id)
			}
		},
		created(){
			if(this.$route.name === "news-page-id"){
				this.routerTo = this.$i18n.path('news/page/')
			}else if(this.$route.name === "column-page-id"){
				this.routerTo = this.$i18n.path('column/page/')
			}
			this.current_page = this.$route.params.id
			this.pages = Math.ceil(this.totalCount/15);
		}
	}
</script>
<style lang="less" scoped>
.page {
		font-weight: 900;
		height: 40px;
		text-align: center;
		color: #666;
		margin: 20px auto 0;
		background: #f2f2f2;
		.pagelist {
			font-size: 0;
			background: #fff;
			height: 50px;
			line-height: 50px;
			span {
				font-size: 14px;
			}
			a {
				font-size: 14px;
				color:#666
			}
			.jump {
				border: 1px solid #ccc;
				padding: 5px 8px;
				-webkit-border-radius: 4px;
				-moz-border-radius: 4px;
				border-radius: 4px;
				cursor: pointer;
				margin-left: 5px;
				input {
					width: 55px;
					height: 26px;
					font-size: 13px;
					border: 1px solid #ccc;
					-webkit-border-radius: 4px;
					-moz-border-radius: 4px;
					border-radius: 4px;
					text-align: center;
				}
			}
			.bgprimary {
				cursor: default;
				color: #fff;
				background: #3278d2;
				border-color: #3278d2;
			}
			.ellipsis {
				padding: 0px 8px;
			}
			.jumppoint {
				margin-left: 30px;
			}
			.gobtn {
				font-size: 12px;
			}
			.bgprimary {
				cursor: default;
				color: #fff;
				background: #3278d2;
				border-color: #3278d2;
			}
			.jump.disabled{
				pointer-events: none;
				background: #f2f4f5;
			}
		}
	}
</style>
